/*
 * AssignModal Messages
 *
 * This contains all the text for the AssignModal component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.AssignModal.header',
    defaultMessage: 'Assign Time Slots {time}',
  },
  meeting: {
    id: 'app.components.AssignModal.meeting',
    defaultMessage: 'Meeting',
  },
  noAssignVideo: {
    id: 'app.components.AssignModal.noAssignVideo',
    defaultMessage: 'You cannot assign a meeting after a video conference link has been added',
  },
});
